import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "AllocationRequestListPage" */
	'pages/supplier/AllocationRequest/AllocationRequestListPage'));

export default [{ component, exact: true, path: '/allocation_requests' }];